import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import 'default-passive-events'
import VueLazyload from 'vue-lazyload'
import '../utils/rem'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  observer: true,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
})
Vue.use(ElementUI)
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.config.productionTip = false
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "zh",
  messages: {
    zh: require("./assets/i18n/zh"),
    en: require("./assets/i18n/en")
  },
  silentTranslationWarn: true
});
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
router.beforeEach((to, from, next) => {
  document.title = to.meta.name || '中国国际煤炭高峰发展论坛';
  next();
})

router.afterEach(() => {
  document.documentElement.scrollTop = 0;
})
